import { EquipmentsRepairFormInstance } from '../types';

export const mapInstance = (instance: Partial<EquipmentsRepairFormInstance>) => {
  return {
    id: instance.id,
    equip_id: instance.equip_id,
    problem_id: Number(instance.service_data.problem.id),
    type_id: Number(instance.type.id),
    department_id: Number(instance.department?.id),
    brand_id: Number(instance.service_data.brand?.id),
    manufacturer_id: Number(instance.service_data.manufacturer.id),
    model_id: Number(instance.service_data.model.id),
    inventory_num: instance.service_data.inventory_num,
    serial_num: instance.service_data.serial_num,
    production_date: Number(instance.service_data.production_date),
    outlet_id: instance.service_data.outlet.id ? Number(instance.service_data.outlet.id) : undefined,
    outlet_name:
      instance.service_data.outlet.legal_name || 
      instance.service_data.outlet.outlet_name,
    address: instance.service_data.address.full_address,
    comment: instance.service_data.comment,
    contacts: instance.contacts,
  };
};